module.exports = __webpack_public_path__ + "img/edit-box-grey.d25e0f74.svg";